import {Paper, Select} from "@mantine/core";
import {useMemo, useState} from "react";
import {Col, Row} from "../../components/Flex/Flex";
import Icon from "../../components/Icon/Icon";
import IconMap from "../../components/Icon/IconMap";
import {useEntityTypes} from "../../utils/api";


const ranges = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export default function ShipWeapons() {
    const {weapons, ships} = useEntityTypes(['weapons', 'ships'], true);

    const shipWeapons = useMemo(() => weapons.filter(w => w.class === "307:1"), [weapons]);

    const [atkShip, setAtkShip] = useState(null);
    const [defShip, setDefShip] = useState(null);

    const showWeapons = useMemo(() => {
        if (atkShip) {
            return shipWeapons.filter(weapon => atkShip.weapons.some(w => w.id === weapon.id));
        }
        return shipWeapons;
    }, [shipWeapons, atkShip]);

    const returnWeapons = useMemo(() => {
        if (defShip) {
            return shipWeapons.filter(weapon => defShip.weapons.some(w => w.id === weapon.id));
        }
        return shipWeapons;
    }, [shipWeapons, defShip]);


    return (
        <div className="w-full">
            <title>Ship Weapons Ranges</title>
            <Row align="center">
                <Col><h1>Ship Weapons</h1></Col>
                <Col grow={1}/>
                <Col><a className="link no-underline" href="https://www.swcombine.com/rules/?Space_Combat" target="_blank" rel="noreferrer"><Icon
                    icon={IconMap.SwcRules}/> Full rules</a></Col>
            </Row>
            <Paper className="mb-3">
                <Row mb={4} wrap={false}>
                    <Col basis="50%">
                        <b>Attacker</b>
                        <Select value={atkShip?.id} data={ships.map(s => ({value: s.id, label: s.name}))} onChange={(v) => {
                            const ship = ships.find(s => s.id === v);
                            setAtkShip(ship);
                        }} searchable clearable/>
                    </Col>
                    <Col basis="50%">
                        <b>Defender</b>
                        <Select value={defShip?.id} data={ships.map(s => ({value: s.id, label: s.name}))} onChange={(v) => {
                            const ship = ships.find(s => s.id === v);
                            setDefShip(ship);
                        }} searchable clearable/>
                    </Col>
                </Row>


                <h3 className="text-center">Attacking</h3>
                <table className="w-full mb-2" style={{borderSpacing: 0}}>
                    <thead>
                    <tr>
                        <th>Weapon</th>
                        <th>Range</th>
                        {ranges.map(r => <th key={r}>{r}</th>)}
                    </tr>
                    </thead>
                    <tbody>

                    {showWeapons.map(weapon => <WeaponRow key={weapon.id} weapon={weapon}/>)}
                    </tbody>
                </table>
                <h3 className="text-center">Return Fire</h3>
                <table className="w-full" style={{borderSpacing: 0}}>
                    <thead>
                    <tr>
                        <th>Weapon</th>
                        <th>Range</th>
                        {ranges.map(r => <th key={r}>{r}</th>)}
                    </tr>
                    </thead>
                    <tbody>
                    {returnWeapons.map(weapon => <WeaponRow key={weapon.id} reverse={true} weapon={weapon}/>)}
                    </tbody>
                </table>

            </Paper>
        </div>
    )
        ;
}


const formatter = new Intl.NumberFormat(undefined, {style: "percent"});

const WeaponRow = ({weapon, reverse = false}) => {

    return (
        <tr>
            <td>{weapon.name}</td>
            <td>{weapon.optimumRange} &plusmn; {weapon.dropOff}</td>
            {ranges.map(r => {
                const delta = Math.abs(weapon.optimumRange - r);
                const chance = Math.max(0, (1 - (0.95 / (1 + Math.exp(-2 * (delta - weapon.dropOff))))) - (0.003 * delta))
                let style = {background: `hsl(${(reverse ? 1 - chance : chance) * 130} 80% 30%)`}
                if (weapon.optimumRange === r) {
                    style.border = "1px solid gold";
                }

                return <td key={r} className="text-right p-1" style={style}>{formatter.format(chance)}</td>
            })}
        </tr>
    )
}
